/* Components */
import { Product } from "@/store/wallet/product.model";
import { ProductCard } from "../ProductCard/ProductCard"

/* Utils */
import { cn } from "@/lib/utils";
import { SettingsStore } from "@/store/settings/settings.store";


export type ProductsGridProps = {
  products: Product[];
}

export const ProductsGrid = ({ products }: ProductsGridProps) => {
  const isSingle = products.length === 1;
  const lang = SettingsStore.getState().getLanguage();

  return (
    <div
      className={cn(
        "grid gap-8 items-start py-6",
        isSingle
          ? "grid-cols-1 place-items-center"
          : "xl:grid-cols-3 lg:grid-cols-2 sm:grid-cols-1"
      )}
    >
      {products.map((product) => (
        <ProductCard
          key={product._id}
          id={product._id}
          name={product.category.translations?.[lang]?.name ?? product.name}
          sku={product.sku}
          image={product.category.pictures.main}
          locked={product.reported}
          gift={product.gift !== null}
        />
      ))}
    </div >
  )
}